import { projectService } from '../api/services';
export async function downloadRoomImages(projectId, room, onProgress = () => {}) {
  if (!room.images?.length) throw new Error('No room images');
  const name = String(room.details?.roomCode || room.id).normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9_-]/g, '-').slice(0, 80) || 'phong';
  // Open the picker while the click still carries browser user activation.
  if (typeof window.showDirectoryPicker !== 'function') {
    const error = new Error('Folder saving requires a supported browser and HTTPS.');
    error.code = 'FOLDER_SAVE_UNSUPPORTED';
    throw error;
  }
  const directory = await window.showDirectoryPicker({ mode: 'readwrite', id: 'bigsix-room-photos', startIn: 'pictures' });
  let next = 0, completed = 0;
  const failures = [];
  const save = async (index) => {
    let image;
    try {
      const url = new URL(room.images[index]);
      if (url.protocol !== 'https:' || url.hostname !== 'res.cloudinary.com') throw new Error('Use authorized image endpoint');
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch(url.href, { credentials: 'omit', cache: 'force-cache', signal: controller.signal });
        if (!response.ok) throw new Error('Image fetch failed');
        image = { data: await response.arrayBuffer(), type: response.headers.get('content-type') };
      } finally { clearTimeout(timer); }
    } catch {
      image = await projectService.roomImage(projectId, room.id, index);
    }
    const { data, type } = image;
    const extension = { 'image/jpeg': 'jpg', 'image/png': 'png', 'image/webp': 'webp', 'image/gif': 'gif', 'image/avif': 'avif' }[String(type).split(';')[0].trim().toLowerCase()];
    if (!extension || !data?.byteLength) throw new Error('Unable to download room image');
    const file = { name: `BigSix-phong-${name}-${String(index + 1).padStart(2, '0')}.${extension}`, blob: new Blob([data], { type: String(type).split(';')[0].trim() }) };
    const handle = await directory.getFileHandle(file.name, { create: true });
    const writer = await handle.createWritable();
    try { await writer.write(file.blob); await writer.close(); }
    catch (error) { await writer.abort().catch(() => {}); throw error; }
    completed++; onProgress(completed, room.images.length);
  };
  // Limit concurrent requests and decoded file buffers, but save each as soon as ready.
  await Promise.all(Array.from({ length: Math.min(4, room.images.length) }, async () => {
    while (next < room.images.length) {
      const index = next++;
      try { await save(index); } catch (error) { failures.push(error); }
    }
  }));
  if (failures.length) throw new Error(`Saved ${completed}/${room.images.length} images: ${failures[0].message}`);
  return { saved: completed, directory: true };
}
